// extracted by css-extract-rspack-plugin
export default {"plasmicQueryBuilderScope":"plasmicQueryBuilderScope-iL55rn"};